<!--
 * @Author: your name
 * @Date: 2021-04-22 11:29:07
 * @LastEditTime: 2021-05-21 14:08:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/index.vue
-->
<template>
  <div>
    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.ourCode" placeholder="外付合同编号（我方）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.brandContractQueryStr" placeholder="所属品牌合同名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.sealApplyUserName" placeholder="盖章申请人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select clearable v-model="formInline.costType" placeholder="未选择项目类型">
          <el-option label="外包服务" :value="1"></el-option>
          <el-option label="媒介采买" :value="2"></el-option>
          <el-option label="杂费" :value="3"></el-option>
          <el-option label="内部采买" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-bottom:20px;">外付合同总数：{{total}}条</div>
    <el-table v-loading="loading" size="small" :data="tableData" style="width: 100%">
      <el-table-column align="center" width="200" prop="ourCode" label="外付合同编号（我方）"></el-table-column>
      <el-table-column align="center" prop="date" label="外付合同附件">
        <template slot-scope="scope">
          <filePreview :fileList="scope.row.fileList"></filePreview>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="date" label="外付成本类型">
        <template slot-scope="scope">
          {{costTypeList[scope.row.costType]}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="money" label="外付金额"></el-table-column>
      <el-table-column align="center" prop="sealType" label="盖章类型">
        <template slot-scope="scope">
          {{sealTypeList[scope.row.sealType]}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="sealOperatorName" label="盖章经办人"></el-table-column>
      <el-table-column align="center" prop="date" label="所属品牌合同">
        <template slot-scope="scope">
          <div>{{scope.row.brandContractName}}</div>
          <div>{{scope.row.brandContractCode}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="sealApplyUserName" label="盖章申请人"></el-table-column>
      <el-table-column align="center" prop="sealApplyTime" label="盖章申请时间"></el-table-column>
      <el-table-column v-if="brandType === 'has'" align="center" prop="auditTime" label="审批时间"></el-table-column>
      <el-table-column align="center" prop="auditStatus" label="审批状态">
        <template slot-scope="scope">
          {{auditStatusList[scope.row.auditStatus]}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="date" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="small" v-if="brandType === 'has'" type="text" @click="detailsClick(scope.row.id)">查看</el-button>
          <el-button size="small" v-else type="text" @click="approvalClick(scope.row)">审批</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="formInline.pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { brandContractAttachmentSealPage } from '@/api/approve/brand';
export default {
  props:['brandType'],
  components: {
  },
  data() {
    return {
      loading:false,
      auditStatusList:['','待直属上级审批','直属上级审批不通过','直属上级审批通过'],
      costTypeList:['','外包服务','媒介采买','杂费','内部采买'],
      sealTypeList:['不盖章','公章','合同章'],
      formInline: {
        auditFlag:this._props.brandType=='stay'?0:1,
        user: "",
        region: "",
        pageNum: 1,
        pageSize: 10,
      },
      tableData:[{}],
      total:0,
    };
  },
  mounted() {
    this.getDataInit()
  },
  methods: {
    //列表数据查询
    getDataInit(){
      this.loading = true;
      brandContractAttachmentSealPage(this.formInline).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.loading = false;
      })
    },
    //查询
    onSearch(){
      this.formInline.pageNum = 1;
      this.getDataInit()
    },
    //查看
    detailsClick(id){
      let router = this.$router.push({
        path: `/check/contractApproval`,
        query: {id,value:'outsideContract',type:1},
      });
      window.open(router.href);
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    //审批
    approvalClick(data){
      let router = this.$router.push({
        path: `/check/contractApproval`,
        query: {
          id:data.id,
          brandContractId:data.brandContractId,
          value:'outsideContract'
        },
      });
      window.open(router.href);
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.getDataInit()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.getDataInit()
    }
  },
};
</script>
<style lang="scss" scoped>
.details-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}

/deep/.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 35px;
    height: 35px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      font-size: 36px !important;
    }
    cursor: pointer;
  }
}
/deep/.select-tag {
  .el-tag__close{
    top: -8px;
  }
}
</style>